module.exports = __webpack_public_path__ + "static/img/contract.8d00d8cf.svg";